import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import * as S from './ProgressStatus.style';

export const ProgressStatus = ({ status }) => {
  const translation = useMemo(
    () => i18n.t(`common-words.${status}`, status),
    [status]
  );

  return (
    <S.Container status={status}>
      <span>{translation}</span>
    </S.Container>
  );
};

ProgressStatus.propTypes = {
  status: PropTypes.oneOf(['in_progress', 'completed', 'pending']),
};
